import PropTypes from "prop-types";
import { NavLink } from "react-router";

/**
 *
 * @param {Array.<{title: string, href?: string}>} links
 * @returns {Element}
 * @constructor
 */
export default function Breadcrumbs({ links }) {
  const breadcrumbs = links.map((link, index) => {
    const { href, title } = link;

    if (index + 1 === links.length) {
      return <li key={title.toLowerCase()}>{title}</li>;
    } else {
      return (
        <li key={title.toLowerCase()}>
          <NavLink unstable_viewTransition to={href}>
            {title}
          </NavLink>
        </li>
      );
    }
  });

  return (
    <div className="breadcrumbs text-sm">
      <ul>
        <li>
          <NavLink unstable_viewTransition to="/">
            Home
          </NavLink>
        </li>
        {breadcrumbs}
      </ul>
    </div>
  );
}

Breadcrumbs.propTypes = {
  links: PropTypes.arrayOf(PropTypes.shape({ title: PropTypes.string, href: PropTypes.any })),
};
